import { useState } from "react";
import useDownloadCSV from "../other/useDownloadCSV.other.hook";

const REPORT_HEADERS = [
  "Ticket Number",
  "Bin Location",
  "Date Received",
  "Status",
  "Customer Business Name",
  "Created At",
  "Updated At",
  "Asset Type",
];

const useAgingTicketsReport = () => {
  const [report, setReport] = useState(null);
  const handleDownload = useDownloadCSV();

  const generateAgingTicketsReport = async (
    tickets,
    filename = "Aging Tickets"
  ) => {
    try {
      const data = [];
      if (!tickets || !tickets.length) throw new Error("No tickets found");
      for (let i = 0; i < tickets.length; i++) {
        const ticket = tickets[i];
        const {
          number,
          properties: { bin_location, date_received },
          status,
          customer_business_then_name,
          created_at,
          updated_at,
          assets,
        } = ticket;
        data.push([
          number || "-",
          bin_location || "-",
          date_received || "-",
          status || "-",
          customer_business_then_name || "-",
          created_at || "-",
          updated_at || "-",
          assets?.[0]?.asset_type || "-",
        ]);
      }
      handleDownload({ data, headers: REPORT_HEADERS, filename });
    } catch (error) {
      console.log(`Error generating aging tickets report: ${error?.message}`);
      alert(`Error generating aging tickets report: ${error?.message}`);
    }
  };

  return { report, setReport, generateAgingTicketsReport };
};

export default useAgingTicketsReport;
